let currentVisitorCache = null
let fetchPromise = null

export const fetchCurrentVisitor = async () => {
  if (currentVisitorCache !== null) {
    return currentVisitorCache
  }

  if (fetchPromise !== null) {
    return fetchPromise
  }

  fetchPromise = (async () => {
    try {
      const response = await fetch('/public_api/current_visitor')

      if (response.ok) {
        const data = await response.json()
        if (data && data.status === 'success' && data.data) {
          currentVisitorCache = data.data
          return currentVisitorCache
        }
      }
      currentVisitorCache = null
      return null
    } catch (error) {
      currentVisitorCache = null
      return null
    } finally {
      fetchPromise = null
    }
  })()

  return fetchPromise
}
